module.exports = __webpack_public_path__ + "img/large-paw-print.421f36cc.png";